import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import VueStore from "../../store/VueStore";
import router from "../../router";
import moment from "moment";
import Chart from "chart.js";
import {
  MstGraphType,
  AuthStoreType,
  Range,
  Threshold,
  alertHistoryType,
  ChartStylesType
} from "../../types/types";
import { getSensorData } from "./scripts/get_sensor_data";
import { getGraphSetting } from "./scripts/get_graph_setting";
import { saveGraphSetting } from "./scripts/save_graph_setting";
import { searchData } from "./scripts/search_data";
import { downloadCsv } from "./scripts/download_csv";
import { reloadKeys, initReloadKeys } from "./scripts/reload_keys";
import { clearUnconfirmedAlert } from "./scripts/clear_unconfirmed_alert";
import { ChartFactory } from "@/common/scripts/chart/chart_factory";
import GraphContentConfig from "./scripts/graph_content_config";
import { reloadGraph } from "./scripts/reload_graph";
import { AuthStoreController } from "@/common/scripts/auth_store_controller";
import MstGraphService from "@/services/mst_graph_service";
import { GraphSettingUpdateFunc } from "./scripts/update_graph_setting";
import VueChartComponent from "@/components/chart/VueChart.vue";
import SearchVueChartComponent from "@/components/searchChart/SearchVueChart.vue";
import { defaultRange, defaultThreshold } from "./scripts/default_values";
import timezoneConfig from "@/common/scripts/time_zone_config";
import { getTableKeySchema } from "./scripts/get_table_key_schema";

@Component({
  components: {
    VueChartComponent,
    SearchVueChartComponent
  }
})
export default class GraphContent extends Vue {
  [key: string]: any;
  public canvasID: string = "";
  public timeZone: string =
    typeof JSON.parse(localStorage.getItem("graphSettings")).useTimeZone ===
      "undefined"
      ? "+09:00"
      : JSON.parse(localStorage.getItem("graphSettings")).useTimeZone;
  public token: string = VueStore.state.token;
  public settingIcon: boolean = true;
  public graphContentArea: boolean = false;
  public graphLoading: boolean = true;
  public graphContent: boolean = true;
  public optionContent: boolean = false;
  public initSettingArea: boolean = false;
  public authStoreSetting: boolean = false;
  public submitButton: boolean = true;
  public changeSetting: boolean = true;
  public submitWait: boolean = false;
  public submitComplete: boolean = false;
  public sensorData: any[] = [];
  public mst_graph: MstGraphType = null;
  public auth_store: AuthStoreType;
  public authStores: AuthStoreType[] = [];
  public chart: Chart;
  public chartFactory: ChartFactory;
  public searchChart: Chart;
  public authStoreName: string = "";
  public newStoreName: string = "";
  public newAccessKey: string = "";
  public newSecretKey: string = "";
  public newRegion: string = "ap-northeast-1";
  public timeFormatChoice: string = "";
  public showOtherFormatBase: boolean = false;
  public timeFormat: string = "";
  public timeFormatToDisplay: string = "";
  public orgTimeFormat: string = "";
  public yearMonthDateSeparator: string = "-";
  public yearMonthDateSeparators = GraphContentConfig.timeFormatItems()
    .yearMonthDate;
  public dateHourSeparator: string = "T";
  public dateHourSeparators = GraphContentConfig.timeFormatItems().dateHour;
  public miliSecFormat: string = "SSS";
  public miliSecFormatChoices = GraphContentConfig.timeFormatItems().miliSec;
  public timezoneToDisplay: string = "Z";
  public selectedTimezoneFormat: string[] = ["[Z]"];
  public timezoneFormatChoices = GraphContentConfig.timeFormatItems().timezone;
  public dataTimezonePicker: boolean = false;
  public dataTimezone: string = this.timeZone;
  public dataTimezones = timezoneConfig;
  public timeFormatToConfirm: string = "";
  public timeFormatItems = GraphContentConfig.timeFormatItems();
  public graphDateFormats = GraphContentConfig.graphDateFormats();
  public drawRangeItems = GraphContentConfig.drawRangeItems();
  public graphDateFormat: string = "MM-DD HH:mm:ss";
  public graphTitle: string = "";
  public graphID: number | null = null;
  public reloadInterval: number = 30;
  public drawRange: string = "300";
  public tableName: string = "";
  public keyTypes: string[] = ["string", "number"];
  public partitionKey: string = "";
  public partitionKeyType: string = "string";
  public sortKey: string = "";
  public sortKeyType: string = "string";
  public targetAttribute: string = "";
  public targetAttributes: string[] = [];
  public targetPartitionKey: string = "";
  public userID: string = JSON.parse(localStorage.getItem("iotKyotoAuth"))
    .userName;
  public latestData: string = null;
  public latestDataDate: string = "";
  public partitions: string[] = [];
  public attributes: string[] = [];
  public mails: string = "";
  public inputAuth: string = "";
  // public inputAccessKey: string = "";
  // public inputSecretAccessKey: string = "";
  public inputTableName: string = "";
  public requireConnectionCheck: boolean = true;
  public defaultAuth: boolean = true;
  public active: number | null = null;
  public defaultLess: boolean = true;
  public defaultMore: boolean = false;
  public defaultSettingMore: boolean = false;
  public authLess: boolean = true;
  public authMore: boolean = false;
  public authSettingMore: boolean = false;
  public tableLess: boolean = true;
  public tableMore: boolean = false;
  public tableSettingMore: boolean = false;
  public thresholdLess: boolean = true;
  public thresholdMore: boolean = false;
  public thresholdSettingMore: boolean = false;
  public graphLess: boolean = true;
  public graphMore: boolean = false;
  public graphSettingMore: boolean = false;
  public selectedAttributes: string = "";
  public selectedPartitions: string = "";
  public newAttributeForm: boolean = false;
  public addAttribute: boolean = true;
  public newPartitionForm: boolean = false;
  public addPartition: boolean = true;
  public newAttribute: string = "";
  public newPartition: string = "";
  public closePartitionForm: boolean = false;
  public closeAttributeForm: boolean = false;
  public reloadEvent: any = null;
  public alertHistory: alertHistoryType[];
  public unconfirmedAlert: alertHistoryType[];
  public displayAlertHistory: alertHistoryType[] = [];
  public displayUnconfirmedAlert: alertHistoryType[] = [];
  public range: Range = defaultRange;
  public searchRange: Range = defaultRange;
  public dynamoRange: Range = defaultRange;
  public threshold: Threshold = defaultThreshold;
  public thresholdSettings: { [k: string]: Threshold } = {
    default: defaultThreshold
  };
  public selectedThresholdKey: string = "default";
  public selectedThreshold: Threshold = defaultThreshold;
  public attributeValueColor = "#32c201";
  public attributeValueColors: { [k: string]: string } = {};
  public lastSendTime: string = "";
  public lastSendTimes: { [k: string]: string } = {};
  public dynamoThreshold: Threshold;
  public alertHistoryContent: boolean = false;
  public searchDataArea: boolean = false;
  public downloadCSVArea: boolean = false;
  public searchPartition: string = "";
  public searchAttribute: string = "";
  public fromDate: string = "";
  public toDate: string = "";
  public periodType: string = "after";
  public searchSelect = GraphContentConfig.searchSelect();
  public searchCanvasID: string = "";
  public closeAuthStoreForm: boolean = false;
  public selectedAuthStore: string = "";
  public addAuthStore: boolean = true;
  public initAddAuthStore: boolean = false;
  public addAuthStoreForm: boolean = false;
  public authStoreProcessMsg: string = "";
  public keyLoading: boolean = false;
  public lineType: string = "line";
  public radioLineID: string = "";
  public radioCurveID: string = "";
  public radioName: string = "";
  public settingCopyContent: boolean = false;
  public graphSettings: Array<{ [key: string]: any }> = [];
  public canvasArea: boolean = true;
  public arrowIcon: boolean = true;
  public latestAttributeValues: { [key: string]: string } = {};

  public chartData: Chart.ChartData = {};
  public searchChartData: Chart.ChartData = {};
  public chartOptions: Chart.ChartOptions = {};
  public searchChartOptions: Chart.ChartOptions = {};
  public chartStyles: ChartStylesType = {
    height: "40vh",
    position: "relative"
  };
  public renderingFlag: boolean = false;
  public searchComponentArea: boolean = false;
  public getKeysButton: string = "hidden";
  public newPartitionKey: string = "";
  public displayAddPartitionKey: boolean = false;
  public graphSettingErrors: string = "";
  public drawGraphError: string = "";
  // CSVダウンロード用のパラメータ格納用
  public downloadCsvPartitionKey: string = "";
  public downloadCsvPeriodType: string = "";
  public downloadCsvFromDate: string = "";
  public downloadCsvToDate: string = "";
  public downloadingCsv: boolean = false;
  // 初期設定Step1で使う変数
  // public defaultName: string = "";
  // public beforeDefaultName: string = "Default";
  // public defaultNameNumber: number | null = null;
  public stepAuthError: string = "";
  public stepError: string = "";
  public newDefaultSettingAccessKey: string = "";
  public newDefaultSettingSecretKey: string = "";
  public newDefaultSettingRegion: string = "ap-northeast-1";
  // public testAuth: string = "";
  // public partitionKeyName: string = "aaa";
  public changeNameAccessKey: string = "";
  public changeNameSecretKey: string = "";
  public partitionAndSortKey: string[] = [];
  public partitionAndSortError: string = "";
  public changeAlertSwitch: boolean = false;
  public thresholdSettingsList: string[] = [];
  public paid: boolean = JSON.parse(localStorage.getItem("graphSettings")).paid;
  public changeAlertDisplay: boolean = false;
  public languageChoices: string = VueStore.state.language;
  public changeLanguageEn: boolean = false;
  public changeLanguageJa: boolean = false;

  @Prop() private graphId!: string;
  @Prop() private regionsList!: string[];

  @Watch("graphId") public async onPropsChange(
    value: string,
    oldValue: string
  ) {
    this.graphID = Number(value);
    await this.graphContentController();
  }

  @Watch("selectedThresholdKey")
  public onSelectdThersholdKeyChange(newValue: string, oldValue: string) {
    if (oldValue !== "default") {
      this.thresholdSettings[oldValue] = this.selectedThreshold;
      this.selectedThreshold = this.thresholdSettings[newValue];
    }
  }

  public async created() {
    this.graphTitle = String(this.$t("message.graphTitle"));
    this.latestDataDate = String(this.$t("message.notAcquired"));
    this.setIDs();
    await this.graphContentController();
    this.inputAuth = "";
    this.inputTableName = "";
    this.active = 0;
    this.stepAuthError = "";
    this.stepError = "";
    // 認証情報が設定されている場合は既存の認証情報を選択した状態にする
    if (this.authStoreName !== "") {
      this.defaultAuth = false;
    }
    // 設定画面のタイムフォーマットの選択状況を設定内容に合わせる
    if (this.timeFormat !== "") {
      this.setTimeFormatForm();
    }
    await reloadKeys(this);
    await getGraphSetting(this);
    await getSensorData(this);
  }

  public mounted() {
    // paidがtrueではない場合、全てfalseにする
    if (this.paid !== true) {
      this.paid = false;
    }
    this.changeAlertSwitchDisplay()
    this.changeLanguage()
  }

  public next() {
    this.stepError = "";
    this.active += 1;
    document.getElementById("next_blur").blur();
    if (this.active > 3) {
      this.active = 3;
    }
  }

  /**
   * タイムフォーマットの設定フォームのセレクタを埋める
   */
  public setTimeFormatForm() {
    this.timeFormatToDisplay = moment("2016-03-16T14:25:35.789Z").format(
      this.orgTimeFormat
    );
    if (this.orgTimeFormat.includes("Z")) {
      this.timeFormatToDisplay = this.timeFormatToDisplay.replace(
        /[+-]\d{2}:\d{2}$/,
        "Z"
      );
    }
    this.timeFormatToConfirm = this.orgTimeFormat;
    if (this.orgTimeFormat.toLowerCase() === "x") {
      this.timeFormatChoice = "unixBasedFormat";
    } else {
      this.timeFormatChoice = "otherFormatBase";
      if (this.orgTimeFormat.indexOf("/") >= 0) {
        this.yearMonthDateSeparator = "/";
      } else if (this.orgTimeFormat.indexOf("-") >= 0) {
        this.yearMonthDateSeparator = "-";
      }
      if (this.orgTimeFormat.indexOf("T") >= 0) {
        this.dateHourSeparator = "T";
      } else {
        this.dateHourSeparator = " ";
      }
      if (this.orgTimeFormat.indexOf("S") >= 0) {
        this.miliSecFormat = "SSS";
      } else {
        this.miliSecFormat = "";
      }
    }
  }

  public moveToStep2() {
    this.stepAuthError = "";
    // バリデーションエラーがある時は処理を中断する
    if (!AuthStoreController.validationCheckDefaultSetting(this)) {
      return;
    }
    if (this.defaultAuth) {
      this.defaultSettingSaveAuthStore();
    }
    this.changeNameAccessKey = `${this.newDefaultSettingAccessKey.slice(
      0,
      3
    )}*****`;
    this.changeNameSecretKey = `${this.newDefaultSettingSecretKey.slice(
      0,
      3
    )}*****`;
    document.getElementById("next_blur").blur();
    this.inputTableName = this.tableName;
    this.requireConnectionCheck = true;
    this.next();
  }

  public moveToStep3() {
    if (this.inputTableName === "") {
      this.stepError = this.$t("message.enterTableName") as string;
      return;
    }
    this.next();
  }

  public moveToStep4() {
    if (this.timeFormat === "") {
      this.stepError = this.$t("message.selectGraphDateFormat") as string;
      return;
    }
    if (this.timeFormat === "x") {
      this.timeFormatToConfirm = this.$t(
        "message.13DigitUnixTimestamp"
      ) as string;
    } else if (this.timeFormat === "X") {
      this.timeFormatToConfirm = this.$t(
        "message.10DigitUnixTimestamp"
      ) as string;
    }
    this.stepError = "";
    this.next();
  }

  public async defaultSettingSaveAuthStore() {
    const self = this;
    if (VueStore.state.token === null) {
      return router.push("/signIn");
    }
    await AuthStoreController.saveNewDefaultSetting(self);
    this.authStoreName = this.inputAuth;
  }

  public back() {
    this.active -= 1;
    document.getElementById("back_blur").blur();
    if (this.active < 1) {
      this.active = 0;
    }
  }

  public async getDescribeTable() {
    // テーブル名の入力チェック
    if (!this.checkTableSettingForm()) {
      return;
    }
    // パーティションキー/ソートキーを取得するAPI呼び出し
    await this.getTableKeySchema();
    this.stepError = "";
    this.outputTableDescriptionErrors();
    document.getElementById("connection_blur").blur();
  }

  /**
   * テーブル情報の取得に失敗した時のエラー表示
   */
  public outputTableDescriptionErrors() {
    if (this.partitionAndSortError === "ResourceNotFoundException") {
      this.stepError = this.$t("message.checkTableName") as string;
    } else if (
      this.partitionAndSortError === "UnrecognizedClientException" ||
      this.partitionAndSortError === "AccessDeniedException"
    ) {
      this.stepError = this.$t("message.checkCredential") as string;
    } else if (this.partitionAndSortError.length > 0) {
      this.stepError = this.$t("message.errorHappened") as string;
    } else {
      this.requireConnectionCheck = false;
    }
  }

  /**
   * テーブル名入力のバリデーションチェック
   */
  public checkTableSettingForm() {
    if (this.inputTableName === "") {
      this.stepError = this.$t("message.enterTableName") as string;
      return false;
    }
    return true;
  }

  public changeSettingButton() {
    this.changeSetting = !this.changeSetting;
  }

  /**
   * GraphContentのコントローラ
   */
  public async graphContentController() {
    try {
      await getGraphSetting(this);
      await getSensorData(this);
      this.graphContentArea = true;
      if (this.reloadInterval > 0) {
        reloadGraph(this, this.reloadInterval);
      }
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * graphIDやradioの初期設定
   */
  public setIDs() {
    this.graphID = this.$props.graphId;
    this.radioLineID = "line" + String(this.graphID);
    this.radioCurveID = "curve" + String(this.graphID);
    this.radioName = "graph-line-type" + String(this.graphID);
  }

  public changeSettingArea() {
    this.graphContent = false;
    this.optionContent = true;
    this.settingIcon = false;
    this.settingCopyContent = false;
  }

  public async changePartition() {
    if (this.targetPartitionKey !== "addPartitionKey") {
      await this.saveGraphSetting();
      await initReloadKeys(this);
      await getSensorData(this);
    } else {
      this.displayAddPartitionKey = true;
    }
  }

  public async saveGraphSettingBySimpleSetting() {
    if (this.initSettingArea) {
      await this.saveInitGraphSetting();
    } else {
      await this.saveGraphSetting();
      this.optionContent = false;
      this.graphContent = true;
      this.settingIcon = true;
    }
    this.active = 0;
  }

  public async changeAttribute() {
    await this.saveGraphSetting();
    await getSensorData(this);
  }

  public displayAuthStoreArea() {
    this.optionContent = !this.optionContent;
    this.authStoreSetting = !this.authStoreSetting;
    this.searchDataArea = false;
    this.settingCopyContent = false;
  }

  public displayAuthStoreAreaFromInitSetting() {
    this.initAddAuthStore = true;
  }

  public displayGraphArea() {
    this.graphContent = true;
    this.optionContent = false;
    this.initSettingArea = false;
    this.settingIcon = true;
    this.searchDataArea = false;
    this.settingCopyContent = false;
  }

  public async switchAlertHistory() {
    this.alertHistoryContent = !this.alertHistoryContent;
    this.graphContent = !this.graphContent;
    this.settingIcon = !this.settingIcon;
    this.optionContent = false;
    this.searchDataArea = false;
    this.settingCopyContent = false;
    if (!this.alertHistoryContent) {
      await clearUnconfirmedAlert(this);
    }
  }

  public switchSearchData() {
    this.alertHistoryContent = false;
    this.searchDataArea = !this.searchDataArea;
    this.graphContent = !this.graphContent;
    this.settingIcon = !this.settingIcon;
    this.optionContent = false;
    this.settingCopyContent = false;
    this.searchAttribute = this.targetAttributes[0];
  }

  public switchDownloadCsv() {
    this.downloadCSVArea = !this.downloadCSVArea;
    this.graphContent = !this.graphContent;
    this.settingIcon = !this.settingIcon;
    this.optionContent = false;
    this.settingCopyContent = false;
  }

  public async saveGraphSetting() {
    const self = this;
    this.thresholdSettings[this.selectedThresholdKey] = this.selectedThreshold;
    if (VueStore.state.token === null) {
      return router.push("/signIn");
    }
    await saveGraphSetting(self);
    this.active = 0;
  }

  public async reloadKeys() {
    try {
      if (!this.dynamoRange || !this.dynamoThreshold) {
        alert(this.$t("message.finishGraphSetupFirst"));
        return;
      }
      this.keyLoading = true;
      await reloadKeys(this);
      await getSensorData(this);
      this.keyLoading = false;
    } catch (e) {
      alert(this.$t("message.failedToGetKeyList"));
      this.keyLoading = false;
      console.error(e);
    }
  }

  public async initReloadKeys() {
    try {
      this.getKeysButton = "loading";
      await initReloadKeys(this);
      this.getKeysButton = "success";
      setTimeout(() => {
        this.getKeysButton = "hidden";
      }, 5000);
    } catch (e) {
      alert(this.$t("message.failedToGetKeyList"));
      this.getKeysButton = "default";
      console.error(e);
    }
  }

  public changeTab(tabName: string) {
    const graphContent = this;
    graphContent[`${tabName}Less`] = !graphContent[`${tabName}Less`];
    graphContent[`${tabName}More`] = !graphContent[`${tabName}More`];
    graphContent[`${tabName}SettingMore`] = !graphContent[
      `${tabName}SettingMore`
    ];
  }

  /**
   * タイムスタンプ設定に応じてモーダルを出すか判断する
   * timeFormat・dataTimezoneからタイムスタンプ設定画面に必要な要素を格納
   */
  public switchIfOtherFormatBase() {
    // UNIXの方で設定がされている場合は何もしない
    if (this.timeFormatChoice !== "otherFormatBase") {
      return;
    }
    this.switchKey("showOtherFormatBase");
    if (this.dateHourSeparator === "T") {
      if (/\[Z\]|[Xx]/.test(this.timeFormat)) {
        this.selectedTimezoneFormat = ["[Z]"];
        this.timezoneToDisplay = "Z";
      } else if (this.timeFormat.includes("ZZ")) {
        this.selectedTimezoneFormat = ["ZZ", this.dataTimezone];
        this.timezoneToDisplay = this.dataTimezone.replace(":", "");
      } else {
        this.selectedTimezoneFormat = ["Z", this.dataTimezone];
        this.timezoneToDisplay = this.dataTimezone;
      }
    } else {
      this.selectedTimezoneFormat = [""];
      this.timezoneToDisplay = "";
    }
    // TZフォーマットの選択のデフォルト表示修正
    if (/\[Z\]|[Xx]/.test(this.timeFormat)) {
      // UIを配慮し、UTC時刻が設定済みの場合はユーザ設定のタイムゾーンをデフォルト表示する
      this.timezoneFormatChoices[2].label = this.timeZone;
      this.timezoneFormatChoices[3].label = this.timeZone.replace(":", "");
    } else {
      this.timezoneFormatChoices[2].label = this.dataTimezone;
      this.timezoneFormatChoices[3].label = this.dataTimezone.replace(":", "");
    }
  }

  /**
   * タイムスタンプ設定がUNIXの場合のAPIパラメータ指定
   */
  public setUnixDataTimezone() {
    // UTC時刻の場合は `dataTimezone` は"+00:00"固定
    this.dataTimezone = "+00:00";
  }

  /**
   * タイムスタンプ設定がUNIX以外の場合の画面表示＆APIパラメータ指定
   */
  public setNewTimeFormat(key: string) {
    // ミリ秒の画面表示
    let milisecToDisplay: string = "";
    let milisecToConfirm: string = "";
    if (this.miliSecFormat) {
      milisecToDisplay = ".789";
      milisecToConfirm = ".SSS";
    }
    // タイムゾーンの画面表示とAPIパラメータ要素を指定
    let timezoneFormat: string = "";
    if (this.selectedTimezoneFormat[1]) {
      timezoneFormat = this.selectedTimezoneFormat[0];
      // フォーマットにTZ情報がある場合は `dataTimezone`にいれる
      this.dataTimezone = this.selectedTimezoneFormat[1];
    } else if (this.selectedTimezoneFormat[0] === "[Z]") {
      timezoneFormat = this.selectedTimezoneFormat[0];
      // UTC時刻の場合は `dataTimezone` は"+00:00"固定
      this.dataTimezone = "+00:00";
    }
    // APIパラメータ `timeFormat` 作成
    const miliSec = this.miliSecFormat
      ? "." + this.miliSecFormat
      : this.miliSecFormat;
    this.timeFormat =
      `YYYY${this.yearMonthDateSeparator}MM${this.yearMonthDateSeparator}DD` +
      `${this.dateHourSeparator}HH:mm:ss` +
      miliSec +
      timezoneFormat;

    // 画面表示用タイムスタンプ作成
    this.timeFormatToDisplay =
      "2016" +
      this.yearMonthDateSeparator +
      "03" +
      this.yearMonthDateSeparator +
      "16" +
      this.dateHourSeparator +
      "14:25:36" +
      milisecToDisplay +
      this.timezoneToDisplay;
    this.timeFormatToConfirm =
      "YYYY" +
      this.yearMonthDateSeparator +
      "MM" +
      this.yearMonthDateSeparator +
      "DD" +
      this.dateHourSeparator +
      "HH:mm:ss" +
      milisecToConfirm +
      this.timezoneToDisplay;
    this.switchKey(key);
  }

  /**
   * タイムスタンプフォーマットのT部分を、TZ情報があるかどうかで自動補正
   */
  public modifyDateHourSeparator() {
    if (this.selectedTimezoneFormat[1]) {
      this.dateHourSeparator = "T";
      // TZ部分のフォーマットがZなのかZZなのかで表示を調整
      if (this.selectedTimezoneFormat[0] === "Z") {
        this.timezoneToDisplay = this.selectedTimezoneFormat[1];
      } else {
        this.timezoneToDisplay = this.selectedTimezoneFormat[1].replace(
          ":",
          ""
        );
      }
    } else if (this.selectedTimezoneFormat[0] === "[Z]") {
      this.dateHourSeparator = "T";
      this.timezoneToDisplay = "Z";
    } else {
      this.dateHourSeparator = " ";
      this.timezoneToDisplay = "";
    }
  }

  /**
   * タイムスタンプフォーマットのTZ部分を、Tがあるかどうかで自動補正
   */
  public modifyTimezoneFormat() {
    if (this.dateHourSeparator === "T") {
      this.selectedTimezoneFormat = ["[Z]"];
      this.timezoneToDisplay = "Z";
    } else {
      this.selectedTimezoneFormat = [""];
      this.timezoneToDisplay = "";
    }
  }

  /**
   * graphContent内の引数の要素の真偽を切り替える
   */
  public switchKey(key: string) {
    const graphContent = this;
    graphContent[`${key}`] = !graphContent[`${key}`];
  }

  public removeKey(keyType: string): void {
    const self = this;
    switch (keyType) {
      case "attributes":
        if (self.selectedAttributes === "") {
          alert(this.$t("message.selectTargetKeyToDelete"));
          break;
        }
        if (self.selectedAttributes === self.targetAttribute) {
          alert(this.$t("message.cantDeleteKeyInUse"));
          break;
        }
        const removeAttributeIndex = self[keyType].indexOf(
          self.selectedAttributes
        );
        self[keyType].splice(removeAttributeIndex, 1);
        self.selectedAttributes = "";
        break;
      case "partitions":
        if (self.selectedPartitions === "") {
          alert(this.$t("message.selectPartitionKeyToDelete"));
          break;
        }
        if (self.selectedPartitions === self.targetPartitionKey) {
          alert(this.$t("message.cantDeleteKeyInUse"));
          break;
        }
        const removePartitionIndex = self[keyType].indexOf(
          self.selectedPartitions
        );
        self[keyType].splice(removePartitionIndex, 1);
        self.selectedPartitions = "";
        break;
      case "authStores":
        if (self.selectedAuthStore === "") {
          alert(this.$t("message.selectCredentialStoreToDelete"));
          return;
        }
        AuthStoreController.remove(self);
        self.selectedAuthStore = "";
        break;
      default:
        break;
    }
  }

  public async addSaveAuthStore() {
    const self = this;
    if (VueStore.state.token === null) {
      return router.push("/signIn");
    }
    await AuthStoreController.saveNew(self);
    this.authStoreName = this.newStoreName;
  }

  public displayAddKey(column: string) {
    const self = this;
    switch (column) {
      case "attribute":
        self.addAttribute = !self.addAttribute;
        self.newAttributeForm = !self.newAttributeForm;
        self.closeAttributeForm = !self.closeAttributeForm;
        self.newAttribute = "";
        break;
      case "partition":
        self.addPartition = !self.addPartition;
        self.newPartitionForm = !self.newPartitionForm;
        self.closePartitionForm = !self.closePartitionForm;
        self.newPartition = "";
        break;
      case "authStores":
        self.addAuthStore = !self.addAuthStore;
        self.closeAuthStoreForm = !self.closeAuthStoreForm;
        self.addAuthStoreForm = !self.addAuthStoreForm;
        self.newStoreName = "";
        self.newAccessKey = "";
        self.newSecretKey = "";
        break;
      default:
        break;
    }
  }

  public saveNewKey(column: string) {
    const self = this;
    switch (column) {
      case "attribute":
        if (self.newAttribute !== "") {
          self.attributes.push(self.newAttribute);
          self.newAttribute = "";
        }
        break;
      case "partition":
        if (self.newPartition !== "") {
          self.partitions.push(self.newPartition);
          self.newPartition = "";
        }
        break;
      default:
        break;
    }
  }

  public async searchData() {
    if (VueStore.state.token === null) {
      return router.push("/signIn");
    }
    await searchData(this);
    this.searchComponentArea = true;
  }

  /**
   * CSVダウンロードボタンのクリック処理
   */
  public async clickDownloadCsv() {
    // トークンがnullの場合はサインイン画面に戻す
    if (VueStore.state.token === null) {
      return router.push("/signIn");
    }
    // CSVダウンロード処理の実行
    await downloadCsv(this);
    this.searchComponentArea = true;
  }

  /**
   * `getDescribeTable`Lambdaへデータを送る
   */
  public async getTableKeySchema() {
    // トークンがnullの場合はサインイン画面に戻す
    if (VueStore.state.token === null) {
      return router.push("/signIn");
    }
    // user_idとstore_name、table_nameをPOSTし、
    // パーティションキー、ソートキーの名前と型を取得する
    await getTableKeySchema(this);
    // this.searchComponentArea = true;
  }

  public async changeTargetAttributes() {
    if (this.targetAttributes.length > 5) {
      alert(this.$t("message.graphsCanHaveMax5Lines"));
      this.targetAttributes.pop();
    } else {
      const updateData: MstGraphType = GraphSettingUpdateFunc.makeSendData(
        this
      );
      await MstGraphService.update(updateData);
      await getGraphSetting(this);
      await getSensorData(this);
    }
  }

  public changeDisplayGetSensorKeysButton() {
    if (
      this.authStoreName !== "" &&
      this.tableName !== "" &&
      this.partitionKey !== "" &&
      this.sortKey !== ""
    ) {
      this.getKeysButton = "default";
    }
  }

  public hiddenAddPartitionKey() {
    this.displayAddPartitionKey = false;
    this.targetPartitionKey = this.mst_graph.targetPartitionKey;
  }

  public addPartitionKey() {
    if (this.newPartitionKey !== "") {
      this.partitions.push(this.newPartitionKey);
      this.targetPartitionKey = this.newPartitionKey;
      this.newPartitionKey = "";
    } else {
      return alert(this.$t("message.enterPartitionKey"));
    }
  }

  public async saveInitGraphSetting() {
    await saveGraphSetting(this);
    await initReloadKeys(this);
    await reloadKeys(this);
    this.initSettingArea = false;
    this.settingIcon = true;
    this.graphContent = true;
  }

  // チェックボックスのカラー連動
  public getCheckBoxStyle(value: string) {
    const checkBoxColorList = [{
      "background": "#184ff4",
      "border-color": "#184ff4"
    }, {
      "background": "#f2930c",
      "border-color": "#f2930c"
    }, {
      "background": "#76821a",
      "border-color": "#76821a"
    }, {
      "background": "#ff5733",
      "border-color": "#ff5733"
    }, {
      "background": "#24262b",
      "border-color": "#24262b"
    }]
    const index = this.targetAttributes.findIndex((element) => element === value)
    if (index === -1) {
      return {}
    } else {
      return checkBoxColorList[index];
    }
  }

  // 閾値設定の追加用
  public addThresholdSettingArea: Array<{ [key: string]: any }> = [{
    addSelectedThresholdKey: "",
    addSelectedThreshold: {
      max: {
        enabled: false,
        value: 0
      },
      min: {
        enabled: false,
        value: 0
      }
    },
    }];

  // 閾値設定5件になったら追加ボタン非表示
  private maxAddCount: number = 5;
  get isMaxAddCount() {
    return (this.addThresholdSettingArea.length >= this.maxAddCount);
  }

  // 閾値設定（アラート）の追加
  public makeNewThresholdSetting() {
    this.addThresholdSettingArea.push(
      {
      addSelectedThresholdKey: "",
      addSelectedThreshold: {
        max: {
          enabled: false,
          value: 0
        },
        min: {
          enabled: false,
          value: 0
        },
      },
    }
    )
  }

  // 閾値設定（アラート）の削除
  public deleteNewThresholdSetting(index: number) {
    this.addThresholdSettingArea.splice(index, 1)
  }

  // Cognitoの有料属性が有効の場合、項目を表示
  public changeAlertSwitchDisplay() {
    if (this.paid === true) {
      this.changeAlertDisplay = true;
    }
    else {
      this.changeAlertDisplay = false;
    }
  }

  // 選択言語によって表記を変更
  public changeLanguage() {
    if (this.languageChoices === "en") {
      this.changeLanguageEn = true;
      this.changeLanguageJa = false;
    }
    else if (this.languageChoices === "ja")  {
      this.changeLanguageJa = true;
      this.changeLanguageEn = false;
    }
  }

  // 表示対象キーの選択肢を制御
  public getThresholdSettingsList() {
    const selectedThresholdList: string[] = [];
    const tempThreshold: any = {};
    for ( let num = 0; num < this.addThresholdSettingArea.length; num++ ) {
      selectedThresholdList.push(this.addThresholdSettingArea[num].addSelectedThresholdKey)
    }
    Object.keys(this.thresholdSettings).map((value) => {
      if (!selectedThresholdList.includes(value)) {
        tempThreshold[value] = this.thresholdSettings[value]
      }
    })
    return tempThreshold
  }

  // 表示対象キーの切替による値の初期化
  public changeSelectedAttributeKey(index: number) {
    this.addThresholdSettingArea[index].addSelectedThreshold = {
      max: {
        enabled: false,
        value: 0
      },
      min: {
        enabled: false,
        value: 0
      }
    };
  }
}
